import type { FunctionComponent, MouseEvent } from "react";

import { ArrowNext, ArrowPrevious, Controls, Dot, DotsContainer } from "./styles";

type Props = {
  activeIndex: number;
  onDotClick: (event: MouseEvent, index: number) => void;
  onNext: (event: MouseEvent) => void;
  onPrevious: (event: MouseEvent) => void;
  totalSlides: number;
};

export const CarouselControls: FunctionComponent<Props> = ({
  activeIndex,
  onDotClick,
  onNext,
  onPrevious,
  totalSlides,
}) => (
  <Controls
    onClick={(event: MouseEvent) => {
      event.stopPropagation();
      event.preventDefault();
    }}
  >
    <DotsContainer>
      {Array.from({ length: totalSlides }, (_, index) => (
        <Dot
          $isActive={index === activeIndex}
          aria-label={`Go to slide ${index + 1}`}
          key={index}
          onClick={event => onDotClick(event, index)}
        />
      ))}
    </DotsContainer>
    <ArrowPrevious
      $isDisabled={activeIndex === 0}
      aria-label="Previous slide"
      onClick={onPrevious}
    />
    <ArrowNext
      $isDisabled={activeIndex === totalSlides - 1}
      aria-label="Next slide"
      onClick={onNext}
    />
  </Controls>
);

CarouselControls.displayName = "CarouselControls";
